module.exports = __webpack_public_path__ + "img/storage_logo_grigio.4688a47c.png";